export default "__VITE_ASSET__DlA6UxoC__"